import React from "react";
import Link from "next/link";
import { IDropdownMenus } from "@/types/menu-d-t";
import Image from "next/image";
import cta_shape from "@/assets/img/cta/menu-cta-shape.png";
import { ifArabic, getLocalizedPath } from "@/utils/language";
import { useTranslation } from "react-i18next";
import { useLanguage } from "@/app/[lang]/client/language-context";

type IProps = {
  dropdown_menus: IDropdownMenus[];
  academics?: boolean;
};

export default function NavSmMegaMenus({ dropdown_menus, academics }: IProps) {
  const midpoint = Math.ceil(dropdown_menus.length / 2);
  const { t } = useTranslation();
  const { language } = useLanguage();

  return (
    <div className="megamenu-demo-small p-relative">
      <div className="tp-megamenu-small-content">
        <div className="row tp-gx-50">
          {!academics && (
            <>
              <div className="col-xl-6">
                <div className="tp-megamenu-list">
                  {dropdown_menus.slice(0, midpoint).map((dm) => (
                    <Link
                      aria-label={dm.title}
                      key={dm.id}
                      href={getLocalizedPath(dm.link || "#", language)}
                    >
                      {ifArabic(dm.titleAr, dm.title)}
                    </Link>
                  ))}
                </div>
              </div>
              <div className="col-xl-6">
                <div className="tp-megamenu-list">
                  {dropdown_menus.slice(midpoint).map((dm) => (
                    <Link
                      aria-label={dm.title}
                      key={dm.id}
                      href={getLocalizedPath(dm.link || "#", language)}
                    >
                      {ifArabic(dm.titleAr, dm.title)}
                    </Link>
                  ))}
                </div>
              </div>{" "}
            </>
          )}
        </div>
        {academics && (
          <div className="d-flex justify-content-between">
            <div className="w-45">
              <div className="tp-megamenu-fullwidth-title">
                <Link
                  aria-label="HTU Schools"
                  href={getLocalizedPath("/htu-schools", language)}
                >
                  {t("htu_schools")}
                </Link>
              </div>
              <div className="tp-megamenu-list">
                {" "}
                {dropdown_menus.slice(0, 4).map((dm) => (
                  <Link
                    aria-label={dm.title}
                    key={dm.id}
                    href={getLocalizedPath(dm.link || "#", language)}
                  >
                    {ifArabic(dm.titleAr, dm.title)}
                  </Link>
                ))}
              </div>
            </div>
            <div className="w-45">
              <div className="tp-megamenu-fullwidth-title">
                <div>{t("deanships")}</div>
              </div>
              <div className="tp-megamenu-list">
                {dropdown_menus.slice(4).map((dm) => (
                  <Link
                    aria-label={dm.title}
                    key={dm.id}
                    href={getLocalizedPath(dm.link || "#", language)}
                  >
                    {ifArabic(dm.titleAr, dm.title)}
                  </Link>
                ))}
              </div>
              <div className="tp-megamenu-fullwidth-title mt-20 pt-15 faculty-title">
                <Link
                  aria-label="Faculty Members"
                  href={getLocalizedPath("/faculty-members", language)}
                >
                  {t("faculty_members")}
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
      {academics && (
        <div
          className="tp-megamenu-small-cta-wrap d-none d-xl-block"
          style={{
            direction: "ltr",
            fontFamily: "ScalaSansPro",
          }}
        >
          <div className="row">
            <div className="col-xl-12 relative">
              <div className="tp-megamenu-small-cta d-flex">
                <h4 className="tp-megamenu-small-cta-title">
                  Study Alone, Play Together
                </h4>
                <div className="tp-megamenu-small-cta-btn">
                  <Link
                    aria-label="Join HTUx Now!"
                    className="tp-btn"
                    href="https://htux.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Join HTUx Now!
                  </Link>
                </div>
                <div className="tp-megamenu-small-cta-thumb">
                  <Image
                    src={cta_shape}
                    alt="cta-shape"
                    width={148}
                    height={110}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
